import { useMutation } from '@apollo/react-hooks';
import { CREATE_STORY_AUDIENCE_ADS_MUTATION, kmsClient } from 'api';
import {
  CreateStoryAudienceAdsMutation,
  CreateStoryAudienceAdsMutationVariables
} from './__generated__/CreateStoryAudienceAdsMutation';

export const useCreateStoryAudienceAds = () => {
  return useMutation<CreateStoryAudienceAdsMutation, CreateStoryAudienceAdsMutationVariables>(
    CREATE_STORY_AUDIENCE_ADS_MUTATION,
    {
      client: kmsClient
    }
  );
};
